<template>
    <div class="bg-hh-grey-900/50 rounded-full h-10 w-10 flex justify-center items-center shadow-center z-10 object-details-toggle"
         @mouseenter="this.hovering = true"
         @mouseleave="this.hovering = false"
         @click.prevent.stop="openDetails"
    >
        <img src="/assets/img/frontend-v3/icons/global/icon-camera-grey-50.svg"
             width="16"
             height="16"
             class="w-4 h-4 inline align-middle transition-opacity"
             alt="camera">
        <div v-if="false" class="opacity-0 pointer-events-none absolute transition-opacity">
            <span class="text-white">{{ count > 15 ? '15+' : count }}</span>
        </div>
    </div>
</template>

<script lang="ts">

export default {
    name: "ObjectDetailsTrigger",

    data() {
        return {
            tooltipRef: ''
        };
    },

    props: [
        'reference',
        'target',
        'count'
    ],

    created() {
        this.tooltipRef = 'tooltip-img-count-' + this.reference;
    },

    methods: {
        openDetails() {
            this.Bus.emit('set-object-details', {
                reference: this.reference,
                target: this.target,
            });

        },
    },
};
</script>

<style>
    .object-details-toggle:hover {
        img {
            opacity: 0;
        }

        div {
            opacity: 1;
        }
    }
</style>

